import {
  LessonComponentResponseType,
  SorterComponent
} from '../../../models/LessonComponent';

import React from 'react';
import { SorterCategory } from '../../../models/LessonComponentContent';
import { SorterEditor } from './SorterEditor';
import { SorterView } from './SorterView';
import { useLessonContext } from '../../../models/LessonContext';

interface SorterProps {
  component: SorterComponent;
  response: LessonComponentResponseType;
  onChange: (response: LessonComponentResponseType) => void;
}

export function Sorter(props: SorterProps) {
  const { mode } = useLessonContext();

  return mode === 'edit' ? (
    <SorterEditor component={props.component} />
  ) : (
    <SorterView
      component={props.component}
      response={props.response as SorterCategory[]}
      onChange={props.onChange}
    />
  );
}
